import { SCREEN } from '../../utils/constants';
import { appointmentChannelId, appointmentDateRange, form, initUI, isDesktopVer, limitRightCarousel, procedureIdSelected, procedures, selectedDateElement, selectedDatetime, selectedProcedures, setCarouselCountLeft, setSelectedDateElement, setSelectedDatetime, shouldCollectPatientInfoFirstForWidget, staffId } from '../../utils/variables';
import { loadAppoimentsList, loadAvailableMonths, loadOnlyAppointmentList } from '../../views/components/timeSelect';
import { renderStaffInfoHeader } from '../actions/InfoStaffAppointment';
import { getProviderFullName } from '../actions/providerActions';
import { clickDateCarouselItem, clickOnlyDateCarouselItem } from '../actions/selectTimeActions';
import { navigate } from './movePages';

export function selectTimeListeners() {
    const dateLeftBtn = document.querySelector('.date__left');
    const dateRightBtn = document.querySelector('.date__right');
    const dateContainer = document.querySelectorAll('.selectTime-carousel__item');
    const selectTimeItemWidth = document.querySelector('.selectTime__carousel').offsetWidth - document.querySelector('.date__right').offsetWidth * 2;
    const selectTimeCarouselItemButtonsDom = document.querySelectorAll('.selectTime__container .selectTime__wrappers .selectTime__carousel .selectTime-carousel__list .selectTime-carousel__item button');

    document.querySelectorAll('.selectTime__container .selectTime-carousel__item').forEach(element => {
        element.style.flexBasis = `${selectTimeItemWidth * 0.2}px`;
    });

    loadAvailableMonths();

    let allFirstDayOfMonthIndex = findAllIndexFirstDayOfMonth();
    let anchorIndexList = [];

    anchorIndexList.push(0);

    const selectTimeMonthItems = document.querySelectorAll('.selectTime__info--available-month');

    let testIndex = 0;
    let testRs = [];
    while (testIndex < limitRightCarousel) {
        let monthMovement = [];
        appointmentDateRange.monthArr.forEach((monthObj) => {
            if (monthObj.id === 0) {
                monthMovement.push({
                    monthId: monthObj.id,
                    pixel: 0,
                    isAddAnchor: false,
                });
            } else {
                let isInViewPort = Math.floor((allFirstDayOfMonthIndex[monthObj.id] / 5)) === testIndex;
                let prevPixel = testRs[testIndex - 1] ? (testRs[testIndex - 1][monthObj.id]?.pixel || 0) : 0;
                monthMovement.push({
                    monthId: monthObj.id,
                    pixel: !isInViewPort ? (prevPixel + selectTimeItemWidth) : (prevPixel + (selectTimeItemWidth * ((allFirstDayOfMonthIndex[monthObj.id] % 5) / 5))),
                    isAddAnchor: isInViewPort,
                });
            }
        });
        testRs.push(monthMovement);
        testIndex++;
    }


    let countLeft = 0;
    let oldPosition = countLeft * selectTimeItemWidth;
    if (dateRightBtn) {
        dateRightBtn.addEventListener('click', () => {
            countLeft += 1;
            setCarouselCountLeft(countLeft);
            if (countLeft >= limitRightCarousel) {
                dateRightBtn.classList.add('date__left-right--disable');
            }
            dateContainer.forEach((element) => { element.style.transform = `translateX(${-selectTimeItemWidth * (countLeft)}px)`; });

            selectTimeMonthItems.forEach((element, index) => {
                if (!anchorIndexList.includes(index)) {
                    element.style.transform = `translateX(${-testRs[countLeft - 1][index].pixel}px)`;
                }
                if (testRs[countLeft - 1][index].isAddAnchor) anchorIndexList.push(index);
            });

            oldPosition = -selectTimeItemWidth * countLeft;
            if (oldPosition < 0) {
                dateLeftBtn.classList.remove('date__left-right--disable');
            }
        });
    }
    if (dateLeftBtn) {
        if (oldPosition === 0) {
            dateLeftBtn.classList.add('date__left-right--disable');
        }
        dateLeftBtn.addEventListener('click', () => {
            if (oldPosition < 0) {
                dateLeftBtn.classList.remove('date__left-right--disable');
                countLeft -= 1;
                setCarouselCountLeft(countLeft);
                oldPosition += selectTimeItemWidth;
                dateContainer.forEach((element) => { element.style.transform = `translate3d(${oldPosition}px,0px,0px)`; });
            }
            if (oldPosition === 0) {
                dateLeftBtn.classList.add('date__left-right--disable');
            }
            if (countLeft <= limitRightCarousel) {
                dateRightBtn.classList.remove('date__left-right--disable');
            }

            selectTimeMonthItems.forEach((element, index) => {
                if (testRs[countLeft][index].isAddAnchor) anchorIndexList.pop();
                if (!anchorIndexList.includes(index) && testRs[countLeft - 1]) {
                    element.style.transform = `translateX(${-testRs[countLeft - 1][index].pixel}px)`;
                }
            });
        });
    }

    // Bind click event for carousel item
    if (selectTimeCarouselItemButtonsDom?.length) {

        selectTimeCarouselItemButtonsDom.forEach(element => {
            handleSelectTime.bind(element);
            element.addEventListener('click', handleSelectTime);
            setSelectedDatetime(null);
        });
        if (procedureIdSelected && staffId && !shouldCollectPatientInfoFirstForWidget) {
            return
        }
        const firstEnabled = Array.from(selectTimeCarouselItemButtonsDom).find(btn => !btn.closest('.selectTime-carousel__item')?.classList.contains('disabled'));
        if (firstEnabled) {
            const unixTime = parseInt(firstEnabled.dataset.datetimeValue);
            if (unixTime) {
                clickDateCarouselItem(unixTime);
            } else {
                firstEnabled.click();
            }
        }
    }
}

const convertAbbreviatedMonth = (abbreviatedMonth) => {
    return moment(abbreviatedMonth, 'MMM').format('MMMM');
}

export const leadMonthCurrent = (index) => {
    const monthTitleElement = document.querySelector('.selectOnlyDate__container .selectOnlyTime__title .selectTime__info');
    const dateContainer = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item-Month');
    if (monthTitleElement) {
        monthTitleElement.innerHTML = convertAbbreviatedMonth(dateContainer[index].dataset.month) ?? "";
    }
}

export function selectOnlyTimeListeners() {
    const dateLeftBtn = document.querySelector('.selectOnlyDate__container .date__left');
    const dateRightBtn = document.querySelector('.selectOnlyDate__container .date__right');
    const dateContainer = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item-Month');
    const dateList = document.querySelector('.selectOnlyDate__container .selectOnlyTime-carousel__list');
    const selectTimeItemWidth = document.querySelector('.selectOnlyDate__container .selectTime__carousel')?.offsetWidth || 0;
    const selectTimeCarouselItemButtonsDom = document.querySelectorAll('.selectOnlyDate__container .selectTime-carousel__item button');
    let currentWidth = 0
    const maxWidth = (dateContainer.length - 1) * selectTimeItemWidth;
    leadMonthCurrent(Math.floor(currentWidth / selectTimeItemWidth) || 0)

    document.querySelector(".selectOnlyDate__container .selectTime__wrappers").style.backgroundColor = "#fff";

    const widthItem = Math.floor((selectTimeItemWidth - 24) / 7) || 0;
    if (widthItem > 0 && widthItem < 44) {
        const dates = document.querySelectorAll(".selectOnlyDate__container .date");
        dates.forEach(date => {
            date?.style.setProperty("--width-item", `${widthItem}px`);
        });
    }

    if (dateRightBtn) {
        dateRightBtn.addEventListener('click', () => {
            currentWidth = currentWidth + selectTimeItemWidth
            if (currentWidth >= maxWidth) {
                dateRightBtn.classList.add('date__left-right--disable');
            }
            leadMonthCurrent(Math.floor(currentWidth / selectTimeItemWidth))
            dateList.style.transform = `translateX(-${currentWidth}px)`;
            if (currentWidth > 0) {
                dateLeftBtn.classList.remove('date__left-right--disable');
            }
        });
    }
    if (dateLeftBtn) {
        if (currentWidth === 0) {
            dateLeftBtn.classList.add('date__left-right--disable');
        }
        dateLeftBtn.addEventListener('click', () => {
            currentWidth = currentWidth - selectTimeItemWidth
            if (currentWidth <= 0) {
                dateLeftBtn.classList.add('date__left-right--disable');
            }
            leadMonthCurrent(Math.floor(currentWidth / selectTimeItemWidth))
            dateList.style.transform = `translateX(-${currentWidth}px)`;
            if (currentWidth < maxWidth) {
                dateRightBtn.classList.remove('date__left-right--disable');
            }
        });
    }

    // Bind click event for carousel item
    selectTimeCarouselItemButtonsDom.forEach(element => {
        handleSelectTime.bind(element);
        element.addEventListener('click', handleSelectTime);
        setSelectedDatetime(null);
    });

    const firstEnabled = Array.from(selectTimeCarouselItemButtonsDom).find(btn => !btn.closest('.selectTime-carousel__item')?.classList.contains('disabled'));
    if (firstEnabled) {
        const unixTime = parseInt(firstEnabled.dataset.datetimeValue);
        if (unixTime) {
            clickOnlyDateCarouselItem(unixTime);
        }
    }
}

function handleSelectTime() {
    const item = this.closest('.selectTime-carousel__item');
    if (item?.classList.contains('disabled')) return;

    const isBookAppointmentFlow = ((staffId && procedureIdSelected || (appointmentChannelId && form?.appointment_channel?.procedures?.length > 1 && selectedProcedures))) && !shouldCollectPatientInfoFirstForWidget
    const className = isBookAppointmentFlow ? '.selectOnlyDate__container .selectTime-carousel__item' : '.selectTime__wrappers .selectTime__carousel .selectTime-carousel__list .selectTime-carousel__item';
    const clickedDatetime = parseInt(this.dataset.datetimeValue);

    if (selectedDatetime !== clickedDatetime) {
        if (selectedDateElement) {
            selectedDateElement?.classList.remove('date--selected');
        }
        setSelectedDatetime(clickedDatetime);
    }

    const dateElement = document.querySelector(`${className}  button[data-datetime-value="${this.dataset.datetimeValue}"] .date`);
    dateElement?.classList.add('date--selected');
    setSelectedDateElement(dateElement);
    setSelectedDatetime(clickedDatetime);

    loadAppoimentsList(clickedDatetime, false);
    if (isBookAppointmentFlow) {
        if (this.dataset.datetimeValue) {
            const formattedDate = moment.unix(this.dataset.datetimeValue).format('dddd, MMMM D');
            document.querySelector('.selectOnlyTime__container .selectOnlyTime__date_selected').innerHTML = `${formattedDate}`;
        } else {
            document.querySelector('.selectOnlyTime__container .selectOnlyTime__date_selected').innerHTML = ``;
        }
        const foundStaff = form?.staff?.find(staff => staff.id === +staffId);
        const foundProcedure = procedures.find(p => p?.id === +procedureIdSelected)
        renderStaffInfoHeader(foundStaff, foundProcedure, 'selectOnlyTime__container')
        document.querySelector('.selectOnlyTime__container .title__content').innerHTML = `Select Time with ${getProviderFullName()}`;

        if (isDesktopVer || (!isDesktopVer && initUI === 'embedded')) {
            document?.querySelector('.selectOnlyTime__container .screen__content')?.style.setProperty('--header-height', '0px')
            document.querySelector('.selectOnlyTime__container .title__wrapper').classList.add("hidden")
        }

        if (!isDesktopVer && initUI === 'embedded') {
            document?.querySelector('.selectOnlyTime__container .infoStaff')?.style.setProperty('display', 'none')
        }

        navigate(SCREEN.SELECT_ONLY_TIME);
        document.querySelector(".selectOnlyTime__list .selectTime__list").innerHTML = ""
        loadAppoimentsList(clickedDatetime, true)
    }
}

function findAllIndexFirstDayOfMonth() {
    let i = 0;
    let len = appointmentDateRange.dateArr.length;
    let rs = {};
    while (i < len) {
        if (appointmentDateRange.dateArr[i].date === 1) {
            rs[appointmentDateRange.dateArr[i].monthId] = i;
        }
        i++;
    }
    return rs;
}

